import * as React from 'react'
import { DialogContext } from './DialogContext'
import ManageUnmappedProductWizard from './ManageUnmappedProduct/ManageUnmappedProductWizard'
import { AddProprietaryListingDetailInput, DisplayTextFormatType, SelectionType } from './ProductListingDialog.types'

interface UnmappedProductDialogWrapperProps {
    projectId?: string
}

/**
 * Wrapper component that renders the ManageUnmappedProductWizard dialog at the top level,
 * outside the virtualized list to prevent unmounting/remounting issues.
 *
 * This component reads the dialog state from DialogContext and conditionally renders
 * the wizard only when both isAddUnmappedOpen and addUnmappedListingId are set.
 */
export const UnmappedProductDialogWrapper: React.FC<UnmappedProductDialogWrapperProps> = ({ projectId }) => {
    const {
        isAddUnmappedOpen,
        addUnmappedListingId,
        handleCloseUnmappedDialog,
        handleUnmappedDialogComplete,
        handleAddProductOption
    } = React.useContext(DialogContext)

    if (!isAddUnmappedOpen || !addUnmappedListingId) {
        return null
    }

    return (
        <ManageUnmappedProductWizard
            open={isAddUnmappedOpen}
            onClose={handleCloseUnmappedDialog!}
            handleAddProductOption={handleAddProductOption! as (listingId: string, selectionType: SelectionType, withManufacturerOption: boolean, withMasterSpecOption: boolean, displayTextFormat: DisplayTextFormatType, addProprietaryListingDetail?: AddProprietaryListingDetailInput) => Promise<void>}
            onComplete={handleUnmappedDialogComplete!}
            listingId={addUnmappedListingId}
            projectId={projectId}
        />
    )
}
